<template>
  <!-- class="player anim-fade-in" -->
  <div
    ref="player"
    class="player test-circle-borders"
    :class="[
      isSquare
        ? {
            player_square: true,
            player_square_with_bounty: lp.bounty,
          }
        : {},
      { player_timetravel: hasTimetravel },
      { player_dealer: lp.is_dealer },
      { player_folded: folded },
      { player_active: lp.is_active },
      { player_bot: lp.is_bot },
      { player_loser: lp.isLoser },
      { player_bet_colored: lp.hasBetColored },
      { player_checkbox: lp.asCheckbox },
      { player_halo: lp.halo },
      { player_checkbox_checked: lp.checked },
      { player_checkbox_hero_checked: lp.heroChecked },
      { player_checkbox_opponent_checked: lp.opponentChecked },
      { player_outer_circle: lp.hasOuterCircle },
      lp.css_class,
      lp.position,
    ]"
    :style="lp.style"
    @click="handleClick"
  >
    <!-- { player_outer_circle: lp.opponentChecked }, -->
    <!-- {{ lp.style }} -->
    <div class="player_inner">
      <div
        v-if="lp.waiting"
        class="player_waiting"
      >
        <WaitingDots style="color: var(--player-primary-color)" />
      </div>
      <!-- <div class="player_name" v-else-if="hasName"> -->
      <div
        v-else
        class="player_name"
      >
        <!-- style="--scale-start: 1; --scale: 1.5; --time: 0.4s" -->
        <div
          v-if="l_animAction"
          class="player_action anim-bounce"
          style="--scale: 1.8; --time: 0.4s"
        >
          <!-- padding-bottom: 0.25em; -->
          {{ lp.action }}
        </div>
        <span
          class="player_name_position"
          :class="{ player_name_position_hidden: l_animAction }"
        >
          <!-- getPlayerHtmlPosition(lp.position) -->
          {{ l_position }}
          <!-- <div
            v-if="lp.username"
            class="player_name_position_username"
            :title="lp.username"
          >
            {{ lp.username }}
          </div> -->
        </span>
      </div>

      <!-- player_stack_visible: stack && !folded -->
      <!-- player_stack_visible: !folded -->
      <!-- class="player_stack" -->
      <span
        class="player_stack"
        :class="{
          player_stack_visible: hasStack,
        }"
      >
        {{ numFixedUnit(w_stack, 'bb') }}
      </span>
    </div>

    <div
      v-if="lp.is_dealer"
      class="player_dealer-chip"
    ></div>
    <!-- class="player_bet player_bet_slide-to-pot player_bet_visible" -->
    <!-- :class="[
        { 'player_bet_slide-to-pot': l_betInPot },
        { player_bet_visible: l_betVisible }
      ]" -->
    <div
      class="player_bet"
      :class="[{ player_cards_empty: cardsEmpty }, w_betClass]"
    >
      <div class="player_bet_inner">
        <!-- <div class="player_bet_coin_cont">
          <div
            class="player_bet_coin_column"
            v-for="(column, wcIdx) in w_coins"
            :key="`${wcIdx}_column`"
          >
            <div
              v-for="(coin, cIdx) in column.coins"
              :key="`${cIdx}_coin`"
              class="player_bet_coin"
              :class="`player_bet_coin_${coin.nomination * 10}`"
            ></div>
          </div>
        </div> -->
        <!-- <PokerChips :chipsGroupedByNomination="w_coins"  /> -->
        <PokerChips :bet="w_chips" />
        <div class="player_bet_money">
          {{ numFixedUnit(w_chips, 'bb') }}
          <!-- {{ w_chips ? numFixed(w_chips, 2) : '' }} -->
        </div>
      </div>
      <slot :name="lp.position" />
    </div>

    <div
      v-if="lp.bounty"
      class="player_bounty csst"
      @click.stop
    >
      <!-- <div class="player_bounty"> -->
      <div class="player_bounty_icon mdi mdi-target"></div>
      <!-- <div class="player_bounty_value">{{ 888 }}</div> -->
      <div class="player_bounty_value">{{ numFixedUnit(lp.bounty, 'bounty') }}</div>
      <div
        v-if="lp.bounty_in_bb"
        class="csst_content d-flex"
        style="position: fixed; transform: translate(0, -1rem) !important; font-size: 0.8rem"
      >
        <span class="player_bounty_icon mdi mdi-target"></span>
        ${{ numFixedUnit(lp.bounty, 'bounty') }}~{{ numFixedUnit(lp.bounty_in_bb, 'bb') }}bb
      </div>
    </div>

    <!-- <div
      v-if="lp.username"
      class="player_username"
      :title="lp.username"
    >
      {{ lp.username }}
    </div> -->

    <div class="player_cards">
      <!-- {{ cards }} -->
      <CardRow
        style="--position: relative"
        cardClass="poker-card_clamped"
        :size="cardsEmpty ? 'small' : 'large'"
        :cards="cards"
        :class="!lp.hand ? 'card-row_shrinked' : ''"
      />
      <!-- :animDelay="
          !lp.hand ? animDelayUnit + distanceFromSB * animDelayUnit : 0
        " -->
      <!-- :class="!lp.hand ? 'card-row_shrinked' : 'card-row_large'" -->
      <!-- :hasSounds="hasSounds" -->
    </div>

    <transition
      name="timebank"
      mode="out-in"
    >
      <div
        v-if="l_timebankMs"
        class="player_timebank"
        style="--pulse-duration: 0.44s"
      >
        <ProgressRing
          :hasNum="true"
          :style="`
          --size: var(--player-circle-size);
          --clr-background: transparent;
          --stroke-width: 4px;
          --anim-duration: ${l_timebankMs}ms;
        `"
          class="player_timebank"
          data-tst="player_timebank"
          :changeColorIntervalMs="1000"
          :getClr="getTimebankColor"
          :max="1"
          :maxCircle="1"
        >
          <template #center>
            <div
              style="background: var(--clr-player-back); border-radius: 50%; padding: 0.25em"
              class="gw_hover-show csst f-center"
              @click="$emit('timebank:stop')"
            >
              <i
                class="mdi icon_btn pa-1 mdi-stop-circle-outline"
                style="font-size: 2em; --after-radius: 50%"
              ></i>
              <div
                class="csst_content text-nowrap"
                style="top: -1.5rem; line-height: 1"
                v-html="$t('common.stop_timebank')"
              ></div>
            </div>
          </template>
        </ProgressRing>
      </div>
    </transition>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import WaitingDots from '@/components/PokerTable/WaitingDots'
import format_mix from '@/mixins/format_mix'
import ProgressRing from '@/components/lib/ProgressRing'
import CardRow from '@/components/CardRow/CardRow'
import PokerChips from '@/components/PokerTable/PokerChips'

export default {
  name: 'PokerPlayer',
  components: {
    WaitingDots,
    CardRow,
    ProgressRing,
    PokerChips,
  },
  mixins: [format_mix],
  props: {
    player: {
      type: Object,
      default: () => {},
    },
    players_props: { default: () => ({}) },
    // hasName: { type: Boolean,  default: true },
    hasStack: { type: Boolean, default: true },
    hasCards: { type: Boolean, default: true },
    hasAction: { type: Boolean, default: true },
    hasTimetravel: Boolean,
    useNext: Boolean,
    betInPot: Boolean,
    isSquare: Boolean,
    asCheckbox: Boolean,
    // distanceFromSB: { default: () => 0 },
    // animDelayDefault: { default: () => 100 },
    // animDelayUnit: { default: () => 80 },
    hasSounds: Boolean,
  },
  emits: ['timebank:stop'],
  data() {
    return {
      w_chips: 0,
      w_coins: [],
      w_stack: 0,
      w_folded: false,
      w_betClass: 'player_bet_no-transition player_bet_invisible',
      w_betClassTimeout: 0,
    }
  },
  mounted() {
    nextTick(() => {
      this.setChips(this.chips)
      this.setCurrentStack(this.stack)
      if (this.isSquare) return
      this.w_betClass = this.chips ? 'player_bet_visible' : 'player_bet_invisible'
    })
  },
  methods: {
    handleClick(e) {
      this.timetravel()
      e.gw_player = {
        player: this.player,
        ref: this.$refs.player,
      }
    },
    getTimebankColor(index) {
      const max = this.lp?.timebank?.seconds

      let sound = ''
      const clr =
        index + 1 >= max
          ? 'var(--clr-error)'
          : index + 3 >= max
            ? 'var(--clr-yellow)'
            : 'var(--clr-primary)'

      if (this.hasSounds) {
        // sound = (index + 3) === max ? 'sound_timebank_5s' :
        // (index + 1) === max ? 'sound_timebank_3s' :
        // ''
        sound = index + 1 === max ? 'sound_timebank_3s' : ''
        if (sound) {
          this.$store.dispatch('sounds_play', sound)
        }
      }
      return clr
    },
    timetravel() {
      if (this.hasTimetravel) {
        this.$store.dispatch('globals_action', `playerjump_${this.player.position}`)
      }
    },
    setChips() {
      if (this.chips) {
        this.w_chips = this.chips
        // this.getCoins()
      } else {
        setTimeout(() => {
          this.w_chips = this.chips
          // this.getCoins()
        }, 150)
      }
    },
    setCurrentStack() {
      if (this.stack) {
        this.w_stack = this.stack
      } else {
        setTimeout(() => {
          this.w_stack = this.stack
        }, 150)
      }
    },
    setBetClass(action) {
      // console.log(action, this.lp.position)
      // debugger
      clearTimeout(this.w_betClassTimeout)
      if (action === 'hide-bet') {
        if (this.w_betClass === 'player_bet_slide-to-pot') {
          this.w_betClassTimeout = setTimeout(() => {
            this.w_betClass = 'player_bet_no-transition player_bet_invisible'
          }, 222)
          return
        }
        this.w_betClass = 'player_bet_no-transition player_bet_invisible'
        return
      }
      if (action === 'show-bet') {
        if (this.w_betClass.includes('player_bet_invisible')) {
          this.w_betClass = 'player_bet_visible'
          return
        }
        if (this.w_betClass.includes('player_bet_slide-to-pot')) {
          this.w_betClass = 'player_bet_no-transition player_bet_invisible'
          nextTick(() => {
            this.w_betClassTimeout = setTimeout(() => {
              this.w_betClass = 'player_bet_visible'
            }, 10)
          })
          return
        }
        this.w_betClass = 'player_bet_visible'
        return
      }
      if (action === 'slide-to-pot') {
        this.w_betClass = 'player_bet_slide-to-pot'
      }
      if (action === 'zap-from-pot') {
        if (this.l_betVisible === 'show-bet') {
          this.w_betClass = 'player_bet_no-transition player_bet_invisible'
          nextTick(() => {
            this.w_betClassTimeout = setTimeout(() => {
              this.w_betClass = 'player_bet_visible'
            }, 10)
          })
          return
        }
        this.w_betClass = 'player_bet_no-transition player_bet_invisible'
      }
    },
  },
  computed: {
    l_timebankMs() {
      if (this.lp.timebank) {
        const vDelay = Date.now() - this.lp.timebank.datenow
        const res = this.lp.timebank.seconds * 1000 - (vDelay + 50)
        return res
      }
      return null
    },
    l_position() {
      if (this.lp.position === 'UTG+1') {
        return 'UTG1'
      }
      if (this.lp.position === 'UTG+2') {
        return 'UTG2'
      }
      if (this.lp.position === 'UTG+3') {
        return 'UTG3'
      }
      return this.lp.position
    },
    l_animAction() {
      return this.lp.action && this.hasAction
    },
    cards() {
      if (this.lp.hand) {
        return this.lp.hand
      }
      if (!this.hasCards || this.folded) {
        return ''
      }
      return 'EeEe'
    },
    cardsEmpty() {
      return !this.cards || this.cards === 'EeEe'
    },
    lp() {
      const playerProps = this.players_props[this.player.position]
      if (playerProps) {
        const res = {
          ...this.player,
          ...playerProps,
        }
        return res
      }
      return this.player
    },
    chips() {
      // console.log(this.useNext ? this.lp?.next_chips_on_table : this.lp?.chips_on_table)
      // if (this.useNext ? this.lp?.next_chips_on_table : this.lp?.chips_on_table) {
      // debugger
      // }
      return this.useNext ? this.lp?.next_chips_on_table : this.lp?.chips_on_table
    },
    stack() {
      return this.useNext ? this.lp?.next_current_stack : this.lp?.current_stack
    },
    folded() {
      return this.useNext ? this.lp?.next_is_folded : this.lp?.is_folded
    },
    l_betVisible() {
      // return (this.chips && !this.folded) ? 'show-bet' : 'hide-bet'
      return this.chips ? 'show-bet' : 'hide-bet'
    },
    l_betInPot() {
      return this.betInPot && this.chips ? 'slide-to-pot' : 'zap-from-pot'
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
  },
  watch: {
    chips: {
      immediate: false,
      handler: 'setChips',
    },
    stack: {
      immediate: false,
      handler: 'setCurrentStack',
    },
    l_betInPot: {
      immediate: false,
      handler: 'setBetClass',
    },
    l_betVisible: {
      immediate: false,
      handler: 'setBetClass',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.bot-turn {
  .remaining-stack {
    .player-name {
      color: var(--clr-opponent);
    }
    border-radius: 50%;
    overflow: hidden;
  }
}

.player {
  --clr-player-primary: var(--clr-hero);
  --clr-player-stroke: var(--clr-trainer_player_active);
  --clr-player-stroke-folded: var(--clr-trainer_player_folded);

  --clr-player-stack-folded: var(--clr-player_folded);
  --clr-player-name-folded: var(--clr-player-name_folded);

  --clr-player-stack: var(--clr-grey-3);
  --clr-player-bet-money: var(--clr-white-0);
  --clr-player-coin: var(--clr-black-3);
  --clr-player-back-default: var(--clr-black-1);
  --clr-player-back: var(--clr-black-1);
  --clr-player-back-folded: var(--clr-black-0);
  --clr-player-back-hover: var(--clr-black-2);

  --clr-player-action: var(--clr-player-primary);
  --clr-player-circle: var(--clr-player-primary);

  --clr-player-outer-circle-color: red;

  // --player-name-size: clamp(0.65rem, 1em, 1rem);
  // --player-action-size: calc(var(--player-name-size) * 1.3);
  // --player-action-size: calc(var(--player-name-size) * 1.125);
  --player-action-size: calc(var(--player-name-size));

  --z-index_inner: 2;
  --z-index_cards: 1;
  --z-index_bet: 2;
  --z-index_dealer-chip: 3;
  --z-index_bounty: 4;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: 0.22s;
  background: var(--clr-player-back);

  &:not(.player_square) {
    @include circle($size: var(--player-circle-size));
    position: absolute;
    border: solid var(--player-border-width) var(--clr-player-stroke);
    border-radius: 50%;
  }
  &_slot {
    position: absolute;
  }
  &_bounty {
    --bounty-inset: 100% auto auto auto;
    --bounty-transform: translate(0, -50%);
    --bounty-clr-back: var(--clr-black-1-3);
    --bounty-padding: 0 0.4em 0 0.25em;
    --bounty-direction: row-reverse;
    --bounty-direction: row;
    --bounty-gap: 0.125em;
    --bounty-value-size: 0.875em;
    --bounty-value-clr: var(--clr-grey-2);
    --bounty-icon-size: 1em;
    --bounty-icon-clr: var(--clr-grey-2);
    --bounty-icon-inset: auto auto auto 0;

    position: absolute;
    display: flex;
    flex-direction: var(--bounty-direction);
    align-items: center;
    justify-content: center;
    line-height: 1.2;
    border-radius: 99px;
    inset: var(--bounty-inset);
    transform: var(--bounty-transform);
    z-index: var(--z-index_bounty);

    padding: var(--bounty-padding);
    background: var(--bounty-clr-back);
    gap: var(--bounty-gap);
    &_icon {
      font-size: var(--bounty-icon-size);
      color: var(--bounty-icon-clr);
      inset: var(--bounty-icon-inset);
    }
    &_value {
      font-size: var(--bounty-value-size);
      border-radius: 99px;
      color: var(--bounty-value-clr);
    }
  }
  &_username {
    position: absolute;
    // top: -1.25em;
    bottom: -0.75em;
    font-size: 0.8em;
    font-weight: 500;
    overflow: hidden;
    white-space: nowrap;
    max-width: 9.5rem;
    text-overflow: ellipsis;
    border-radius: 99px;
    --username-clr-back: var(--clr-black-1);
    --username-padding: 0 0.5em;
    background: var(--username-clr-back);
    padding: var(--username-padding);
    color: var(--clr-player-name);
  }
  &_square {
    --player-name-size: 0.875rem;
    --clr-player-back: var(--clr-black-1-3);

    border-radius: 4px;
    min-width: 3.5em;
    flex: 1;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    &.player_active {
      --clr-player-name: var(--clr-player-primary);
      --clr-player-stack: var(--clr-player-primary);
      &:after {
        background: var(--clr-player-primary);
      }
    }
    &.player_folded {
      --clr-player-back: var(--clr-black-1-3) !important;
    }
    .player_inner {
      padding: 0 0.5em;
      height: unset !important;
      width: unset !important;
      min-height: unset !important;
      min-width: unset !important;
      border-radius: 0 !important;
    }
    .player {
      &_name {
        line-height: unset;
      }
      &_stack {
        font-size: var(--player-name-size);
      }
      &_dealer-chip {
        display: none;
      }
      &_bet_coin {
        display: none;
      }
      &_bet_money {
        display: none;
      }
      &_turn {
        .player_stack {
          color: var(--clr-player-primary) !important;
        }
      }
    }
    &.player_square_with_bounty {
      padding: 0 0.125rem;
      .player_bounty {
        --bounty-value-size: var(--player-name-size);
        --bounty-icon-size: var(--player-name-size);
        --bounty-clr-back: transparent;
        --bounty-transform: none;
        --bounty-padding: 0;
        position: static;
      }
      .player_inner {
        flex-direction: row;
        gap: 0.25rem;
        .player_name_position {
          padding: 0;
        }
      }
    }
  }
  &_inner {
    @include circle($size: var(--player-circle-size));
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    z-index: var(--z-index_inner);
  }
  &_name {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    &_position {
      padding: 0 0.25em;
      color: var(--clr-player-name);
      font-size: var(--player-name-size);
      font-weight: 700;
      line-height: 1.1;
      transition: 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
      &_hidden {
        opacity: 0;
      }
    }
  }
  &_stack {
    color: var(--clr-player-stack);
    font-size: var(--player-name-size);

    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    transition: 0.15s;
    height: 0;
    opacity: 0;
    z-index: 1;
    &_visible {
      opacity: 1;
      height: 1em;
    }
  }

  &_action {
    // padding-bottom: 0.25em;
    color: var(--clr-player-action);
    font-size: var(--player-action-size);
    text-transform: uppercase;
    position: absolute;
    font-weight: 700;
    line-height: 1.1;
  }
  &_waiting {
    position: relative;
    line-height: 1.1;
    height: 1.1em;
  }

  &_active {
    --clr-player-name: var(--clr-player-primary);
    --clr-player-stroke: var(--clr-player-primary) !important;
    --clr-player-stack: var(--clr-white-0);
    --clr-player-name: var(--clr-white-0);
  }
  &_bot {
    --clr-player-primary: var(--clr-opponent) !important;
  }
  &_folded {
    &:not(.player_active) {
      --clr-player-name: var(--clr-player-name_folded);
      --clr-player-stroke: var(--clr-player-stroke-folded) !important;
      --clr-player-back: var(--clr-player-back-folded);
      --clr-player-stack: var(--clr-player-stack-folded);
    }
    &.player_active {
      --clr-player-back: var(--clr-player-back-folded);
      --clr-player-name: var(--clr-black-6);
      --clr-player-stack: var(--clr-black-6);
    }
  }
  &_halo {
    // animation: halo 1s ease-out infinite;
    animation: halo 2.2s ease-out;
    --clr-player-name: var(--clr-player-primary);
    --clr-player-stroke: var(--clr-player-primary);
    --clr-player-stack: var(--clr-white-0);
    --clr-player-name: var(--clr-white-0);
    box-shadow: 0px 0px 16px var(--clr-player-primary);
    @keyframes halo {
      0% {
        box-shadow: 0px 0px 0px var(--clr-player-primary);
      }
      100% {
        box-shadow: 0px 0px 16px var(--clr-player-primary);
      }
    }
    // @keyframes halo {
    //   0% {
    //     box-shadow: 0px 0px 6px var(--clr-player-primary);
    //   }
    //   50% {
    //     box-shadow: 0px 0px 12px var(--clr-player-primary);
    //   }
    //   60% {
    //     box-shadow: 0px 0px 12px var(--clr-player-primary);
    //   }
    //   100% {
    //     box-shadow: 0px 0px 4px var(--clr-player-primary);
    //   }
    // }
    // @keyframes halo {
    //   0% {
    //     box-shadow: 0px 0px 2px var(--clr-player-primary);
    //   }
    //   25% {
    //     box-shadow: 0px 0px 6px var(--clr-player-primary);
    //   }
    //   30% {
    //     box-shadow: 0px 0px 13px var(--clr-player-primary);
    //   }
    //   50% {
    //     box-shadow: 0px 0px 8px var(--clr-player-primary);
    //   }
    //   60% {
    //     box-shadow: 0px 0px 13px var(--clr-player-primary);
    //   }
    //   100% {
    //     box-shadow: 0px 0px 2px var(--clr-player-primary);
    //   }
    // }
  }
  &_dealer-chip {
    @include circle($size: clamp(1rem, 1.25em, 1.25rem));
    background: var(--clr-white-0);
    color: var(--clr-black-0);
    // color: var(--clr-black-0);
    font-weight: 700;
    z-index: var(--z-index_dealer-chip);
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    &:before {
      content: 'D';
      font-size: 0.875rem;
      line-height: 1;
      // height: 0.8rem;
      // width: 0.8rem;
      position: absolute;
    }
  }
  &_bet {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    z-index: var(--z-index_bet);

    opacity: 0;

    --bet-inset-invisible: 0 0;
    --bet-inset: var(--bet-inset-invisible);
    // --bet-gap: 0.125em;
    // --bet-gap: 0.25em;
    --bet-gap: 0.5em;
    --bet-direction: row;
    // --bet-direction: column;
    // --bet-direction: column-reverse;
    // --anim-time: 0.22s;
    --anim-time: 0.33s;
    // --anim-time: 2s;
    transition: opacity var(--anim-time);
    &_inner {
      .player_bet_money {
        opacity: 0;
        // transition: 0.44s;
        transition: 0.55s;
        // transition: 0.66s;
      }
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      grid-gap: var(--bet-gap);
      inset: var(--bet-inset);
      flex-direction: var(--bet-direction);
      transition: var(--anim-time);
    }
    &_no-transition {
      --anim-time: 0s;
    }
    &_visible {
      opacity: 1;
      --bet-inset: var(--bet-inset-visible);
      .player_bet_money {
        opacity: 1;
      }
    }
    &_slide-to-pot {
      opacity: 0;
      --bet-inset: var(--bet-inset-pot);
    }
    &_colored {
      --clr-player-bet-money: var(--clr-player-primary);
      --clr-player-coin: var(--clr-player-primary);
    }
    &_money {
      position: relative;
      display: flex;
      justify-content: center;
      order: 2;
      // padding: 0 0.5rem;
      flex-shrink: 0;
      z-index: 1;
      font-weight: 700;
      color: var(--clr-player-bet-money);
      font-size: var(--player-name-size);
    }
  }

  &_loser {
    --clr-player-primary: var(--clr-error);
  }
  &_cards {
    position: absolute;
    z-index: 1;
  }

  &_checkbox {
    cursor: pointer;
    --clr-player-hero: var(--clr-hero);
    --clr-player-opponent: var(--clr-opponent);
    &_checked {
      --clr-player-stroke: var(--clr-player-primary);
      --clr-player-name: var(--clr-player-primary) !important;
      --clr-player-stack: var(--clr-player-primary);
    }
    &_hero {
      --clr-player-stroke: var(--clr-player-hero);
      --clr-player-name: var(--clr-player-hero) !important;
    }
    &_opponent {
      --clr-player-stroke: var(--clr-player-opponent);
      --clr-player-name: var(--clr-player-opponent) !important;
    }
    &.player_checkbox_hero_checked.player_checkbox_opponent_checked {
      --clr-player-name: var(--clr-white-0) !important;
      // --clr-player-name: var(--clr-grey-2) !important;

      border: var(--player-border-width) solid transparent;
      border-radius: 50%;
      background-size:
        100% 100%,
        100% 50%,
        100% 100%;
      background-repeat: no-repeat;
      background-image: linear-gradient(var(--clr-player-back), var(--clr-player-back)),
        linear-gradient(var(--clr-player-hero) 100%, transparent 100%),
        linear-gradient(var(--clr-player-opponent) 100%, transparent 100%);
      // background-position: center center, left top, right top, left bottom, right bottom;
      background-origin: content-box, border-box, border-box;
      background-clip: content-box, border-box, border-box;
    }
  }
  &_timebank {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &_outer_circle {
    &:after {
      --border-width: var(--player-border-width);
      --size: calc(var(--player-circle-size) + (var(--border-width) * 3));

      content: '';
      position: absolute;
      border-radius: 50%;
      z-index: 1;
      background: transparent;
      height: var(--size);
      width: var(--size);

      border: solid var(--border-width) var(--clr-player-outer-circle-color);
      animation: bounceCircle 0.44s ease-out;
    }
    @keyframes bounceCircle {
      0% {
        opacity: 0;
        box-shadow: 0px 0px 0px 0px var(--clr-player-outer-circle-color);
      }
      50% {
        opacity: 1;
        box-shadow: 0px 0px 0px 8px var(--clr-player-outer-circle-color);
      }
      100% {
        opacity: 1;
        box-shadow: 0px 0px 0px 0px var(--clr-player-outer-circle-color);
      }
    }
  }
}

@media (hover: hover) and (pointer: fine) {
  .player {
    &_timetravel {
      cursor: pointer;
      &:hover {
        .player_name {
          --clr-player-name: var(--clr-player-primary);
        }
        .player_stack {
          --clr-player-stack: var(--clr-player-primary);
        }
      }
    }
    &_square {
      &.player_timetravel:hover {
        --clr-player-back: var(--clr-black-3) !important;
        &:after {
          background: var(--clr-player-primary);
        }
      }
    }
    &_checkbox {
      cursor: pointer;
      &:hover {
        --clr-player-stroke: var(--clr-player-primary);
        --clr-player-name: var(--clr-player-primary);
        --clr-player-stack: var(--clr-player-primary);
        --clr-player-back: var(--clr-player-back-hover);
      }
    }
    &_hoverable {
      cursor: pointer;
      &:hover {
        --clr-player-name: var(--clr-white-0);
        --clr-player-stroke: var(--clr-player-primary);
      }
    }
  }
}
</style>
